import { withLazyLoading } from '@atlaskit/editor-common/lazy-node-view';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { ReactMediaInlineNode } from './mediaInline';
export var lazyMediaInlineView = function lazyMediaInlineView(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent) {
  if (editorExperiment('platform_editor_exp_lazy_node_views', false)) {
    return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent);
  }
  return withLazyLoading({
    nodeName: 'mediaInline',
    getNodeViewOptions: function getNodeViewOptions() {},
    loader: function loader() {
      var result = import( /* webpackChunkName: "@atlaskit-internal_editor-plugin-media-inline-lazy-node-view" */
      './mediaInline').then(function (_ref) {
        var ReactMediaInlineNode = _ref.ReactMediaInlineNode;
        return function (node, view, getPos) {
          return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent)(node, view, getPos);
        };
      });
      return result;
    }
  });
};